import { MapStore } from '../../../../store/Map';
import { MapWidgetRootStore } from '../common/MapWidgetRootStore';

export const logMapWidgetDoc = () => {
  console.log(
    '%cПараметры настройки виджета карты',
    'font-size: 16px; font-weight: bold;',
  );

  console.group('%clayers', 'font-weight: bold');
  console.log('Описание: Список слоёв, отображаемых на карте');
  console.log('Формат: список названий слоёв через запятую');
  console.log('По умолчанию: Яндекс.Карты + карта Ростовской области');
  console.log('Пример: %clayers=yandex,rostov', 'color: #3498db');
  console.groupEnd();

  console.group('%czoom', 'font-weight: bold');
  console.log('Описание: Уровень приближения карты');
  console.log(`Допустимые значения: от 1 до ${MapStore.MAX_ZOOM}`);
  console.log('Пример: %czoom=12', 'color: #3498db');
  console.groupEnd();

  console.group('%ccenter', 'font-weight: bold');
  console.log('Описание: Координаты центра карты');
  console.log(
    `Формат: координаты в проекции ${MapWidgetRootStore.PROJECTION} (x,y)`,
  );
  console.log(
    'Пример: %ccenter=4514498.827516088,6018232.767135088',
    'color: #3498db',
  );
  console.groupEnd();

  console.group('%clegend', 'font-weight: bold');
  console.log('Описание: Управление отображением легенды карты');
  console.log('Допустимые значения:');
  console.log(
    '- %cenable%c - легенда отображается (по умолчанию)',
    'color: #27ae60',
    'color: inherit',
  );
  console.log(
    '- %cdisable%c - легенда скрыта',
    'color: #e74c3c',
    'color: inherit',
  );
  console.log('Пример: %clegend=disable', 'color: #3498db');
  console.groupEnd();

  console.group('%ccard', 'font-weight: bold');
  console.log('Описание: Возможность открытия карточки объекта');
  console.log('Допустимые значения:');
  console.log(
    '- %cenable%c - карточки доступны (по умолчанию)',
    'color: #27ae60',
    'color: inherit',
  );
  console.log(
    '- %cdisable%c - карточки недоступны',
    'color: #e74c3c',
    'color: inherit',
  );
  console.log('Пример: %ccard=disable', 'color: #3498db');
  console.groupEnd();

  console.group('%cnews', 'font-weight: bold');
  console.log('Описание: Отображение новостей на карте');
  console.log('Допустимые значения:');
  console.log(
    '- %cenable%c - новости отображаются',
    'color: #27ae60',
    'color: inherit',
  );
  console.log(
    '- %cdisable%c - новости скрыты (по умолчанию)',
    'color: #e74c3c',
    'color: inherit',
  );
  console.log('Пример: %cnews=enable', 'color: #3498db');
  console.groupEnd();

  console.group('%cevents', 'font-weight: bold');
  console.log('Описание: Отображение афиши/мероприятий на карте');
  console.log('Допустимые значения:');
  console.log(
    '- %cenable%c - афиша отображается',
    'color: #27ae60',
    'color: inherit',
  );
  console.log(
    '- %cdisable%c - афиша скрыта (по умолчанию)',
    'color: #e74c3c',
    'color: inherit',
  );
  console.log('Пример: %cevents=enable', 'color: #3498db');
  console.groupEnd();
};
